module.exports = __webpack_public_path__ + "img/aws.cb6c6103.jpg";